import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData,
  type CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostError,
  type CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponse,
  createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPost,
} from '../../generated';

export type CreateOrganizationIcpProductCategoryMutationVariables =
  CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData['path'];

export type CreateOrganizationIcpProductCategoryMutation =
  CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponse;

export const useCreateOrganizationIcpProductCategoryMutation = <
  TError = CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      CreateOrganizationIcpProductCategoryMutation,
      TError,
      CreateOrganizationIcpProductCategoryMutationVariables,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<
    CreateOrganizationIcpProductCategoryMutation,
    TError,
    CreateOrganizationIcpProductCategoryMutationVariables,
    TContext
  >({
    mutationKey: ['CreateOrganizationIcpProductCategory'],
    mutationFn: async ({ org_id, icp_product_category_id }: CreateOrganizationIcpProductCategoryMutationVariables) => {
      const { data } =
        await createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPost({
          path: { org_id, icp_product_category_id },
          throwOnError: true,
        });
      return data;
    },
    ...options,
  });
};

useCreateOrganizationIcpProductCategoryMutation.fetcher = (
  { org_id, icp_product_category_id }: CreateOrganizationIcpProductCategoryMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } =
      await createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPost({
        path: { org_id, icp_product_category_id },
        throwOnError: true,
      });
    return data;
  };
};
